// extracted by mini-css-extract-plugin
export default {"washCodePage":"WashCodePage_washCodePage__K5CT0","wrapper":"WashCodePage_wrapper__K1Mzm","mainContent":"WashCodePage_mainContent__VU6sr"};